module.exports = __webpack_public_path__ + "img/default-picture-dark.99aa2501.svg";